

































































































































import { Component, Vue } from 'vue-property-decorator';
import { BillTemplateSearchResponse, BillTemplateOverviewResponse } from '@/models/billTemplateResponse';
import { EnabledTypes } from '@/enums/enabledTypes';
import { BillTypes } from '@/enums/billTypes';
import { BillStatusTypes, getBillStatusTypeName } from '@/enums/billStatusTypes';
import { getPaymentStatusTypeName, PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import Axios from 'axios';
import moment from 'moment';
import { BillTemplateSearchRequest } from '@/models/billTemplateRequest';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({})
export default class BillTemplateList extends AvaivaledVue {
  private EnabledTypes = EnabledTypes;
  private BillTypes = BillTypes;

  private isLoading: boolean = false;
  private billTemplateList: BillTemplateOverviewResponse[] = [];
  private countAll: number = 0;

  private showSearchCondition = true;
  get condition() {
    return this.$store.state.bill.billTemplateCondition;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }
  }

  public async mounted() {
    await this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    this.isLoading = true;

    try {
      await this.$store.dispatch('bill/fetchBillSettings');

      const req: BillTemplateSearchRequest = {
        perPage: this.condition.perPage,
        page: this.condition.page,
        sort: this.condition.sort,
        enabled: this.condition.enabledType === EnabledTypes.None
          ? null
          : this.condition.enabledType === EnabledTypes.Enabled,
        billType: this.condition.billType || null,
        billDateFrom: this.condition.billDateFrom,
        billDateTo: this.condition.billDateTo,
        billLimitDateFrom: this.condition.billLimitDateFrom,
        billLimitDateTo: this.condition.billLimitDateTo,
        keyWord: this.condition.keyWord,
      };
      const res = await Axios.post<BillTemplateSearchResponse>('/api/bill-templates', req);
      this.billTemplateList = res.data.billTemplates;
      this.countAll = res.data.countAll;
    } catch (error) {
      this.billTemplateList = [];
    }

    this.isLoading = false;
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private formatBillDate(row: BillTemplateOverviewResponse) {
    if (row.billDateCreationMonth === null) {
      return '未指定';
    }

    switch (row.billDateCreationMonth) {
      case 0:
        return `当月 ${row.billDateCreationDay}日`;
      case 1:
        return `翌月 ${row.billDateCreationDay}日`;
      case 2:
        return `翌々月 ${row.billDateCreationDay}日`;
      default:
        return '未指定';
    }
  }

  private formatBillLimitDate(row: BillTemplateOverviewResponse) {
    if (row.billLimitDateCreationMonth === null) {
      return '未指定';
    }

    switch (row.billLimitDateCreationMonth) {
      case 0:
        return `当月 ${row.billLimitDateCreationDay}日`;
      case 1:
        return `翌月 ${row.billLimitDateCreationDay}日`;
      case 2:
        return `翌々月 ${row.billLimitDateCreationDay}日`;
      default:
        return '未指定';
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: BillTemplateOverviewResponse, column: any) {
    this.$router.push(`/bill/bill-templates/${row.billTemplateId}/edit`);
  }

  private onCreateBillTemplate() {
    this.$router.push('/bill/bill-templates/create');
  }

}
